export default (observer, fieldName, rules, rulePrefixToCheck = 'check') => {
  if (!observer.fields[fieldName] || !rules || rules === 'required') return false;

  const field = observer.fields[fieldName];
  const validationRules = Object.keys(rules);
  const checkedRule = validationRules.find((ruleItem) => ruleItem.includes(rulePrefixToCheck));

  const failedRules = Object.keys(field?.failedRules);
  return failedRules.some((failedRuleItem) => failedRuleItem === checkedRule);
};
